export enum UserTypeEnum {
  full = 'full',
  department = 'department',
  subDepartment = 'subDepartment',
  noData = 'noData',
}
